import React from 'react'
import { useFormContext } from 'react-hook-form'
import ICSSelectInput, {
  Option
} from '../../../../components/ICSSimpleSelectInput/ICSSelectInput'
import { AnalyzerFormValues } from '../analyzerForm.types'

interface Props {
  name: keyof AnalyzerFormValues
  label: string
  options: Option[]
  isRequired?: boolean
}

export const AnalyzerDropdown = (props: Props) => {
  const { control } = useFormContext<AnalyzerFormValues>()
  return <ICSSelectInput {...props} control={control} />
}

export default AnalyzerDropdown
